export default __webpack_public_path__ + "static/media/GIFCoche.3b3f10f3.gif";